import type { TFunction } from 'i18next';
import {
  u3147IsManualEndBeforeOrAtStart,
  type U3147ManualTimeField,
} from './u3147FormatDuration';

const NS = 'u3147';

export interface U3147WorkDayEndMessageContext {
  useDurationMode: boolean;
  startTime: string;
  endTime: string;
}

export function u3147BuildWorkDayEndFieldMessage(
  field: U3147ManualTimeField,
  context: U3147WorkDayEndMessageContext,
  t: TFunction,
): string {
  if (field === 'durationMinutes' || (field === 'endTime' && context.useDurationMode)) {
    return t('msgWorkDayDurationExceeded', {
      ns: NS,
      defaultValue:
        "La durée saisie dépasse 24:00 pour la date de travail ; réduisez la durée ou avancez l'heure de début.",
    });
  }
  if (u3147IsManualEndBeforeOrAtStart(context.startTime, context.endTime)) {
    return t('msgWorkDayEndBeforeStart', {
      ns: NS,
      defaultValue:
        "L'heure de fin doit être postérieure à l'heure de début, au plus tard à 24:00.",
    });
  }
  return t('msgWorkDayEndExceeded', {
    ns: NS,
    defaultValue: "L'heure de fin ne peut pas dépasser 24:00 pour la date de travail.",
  });
}
